import React from "react"
import { Link } from "gatsby"

const KnowledgeHubFooterMenu = () => {
  return (
    <React.Fragment>
      <Link to="/articles">Articles</Link>
      <Link to="/faq">FAQ</Link>
      <Link to="/videos">Technical Videos</Link>
    </React.Fragment>
  )
}

export default KnowledgeHubFooterMenu
